import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const VerifiedBadge: React.FC<{ sx?: object }> = ({ sx }) => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                color: '#EB4F2F',
                ...sx,
            }}
        >
            <CheckCircleIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
            <Typography
                variant="caption"
                sx={{
                    fontWeight: 400,
                    lineHeight: 1,
                    fontSize: '0.75rem',
                    whiteSpace: 'nowrap',
                }}
            >
                <Box component="span" sx={{ fontWeight: 700 }}>Suntap</Box> Verified
            </Typography>
        </Box>
    );
};

export default VerifiedBadge; 